export const isValidFieldName = /^[\p{Letter}_][\p{Letter}\p{Number}_]*$/u;
export const isValidHeaderName = /^[\p{Letter}\p{Number}_-]+$/u;
export const isValidHandleBarName = /^[\p{Letter}\p{Number}]+([.][\p{Letter}\p{Number}]+)*$/iu;
export const isValidHandleBarNameWithTrailingDot = /^[\p{Letter}\p{Number}]+(([.][\p{Letter}\p{Number}]+)*)[.]?$/iu;
export const noWhitespace = /[^-\s]/;
